import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import SEO from '../components/SEO';
import { SitePage, PageHero, CtaBand } from '../components/site/ui';
import { BRAND, NAV } from '../components/site/brand';

/** Shown for any URL that doesn't match a page (instead of a blank screen). */
const NotFoundPage = () => (
  <SitePage>
    <SEO title="Page not found" description="This page doesn't exist. Browse VK Tours holiday packages or contact our team." path="/404" noindex />
    <PageHero
      short
      crumbs={[{ label: 'Home', to: '/' }, { label: 'Page not found' }]}
      kicker="Error 404"
      title="Page"
      accent="not found"
      lede="The link may be old or mistyped. Try one of these, or tell us where you want to go."
    >
      <Link className="vk-btn vk-btn--hot" to="/tour-packages">See all packages</Link>
      <a className="vk-btn vk-btn--ghost" href={BRAND.phoneLink}><Phone size={18} /> {BRAND.phone}</a>
    </PageHero>
    <section className="vk-section">
      <div className="vk-wrap">
        <p className="vk-kicker">Popular right now</p>
        <ul className="vk-chips">
          {[...NAV.international.slice(0, 6), ...NAV.india.slice(0, 4)].map((d) => (
            <li key={d.path}><Link className="vk-chip" to={d.path}>{d.name}</Link></li>
          ))}
        </ul>
      </div>
    </section>
    <CtaBand />
  </SitePage>
);

export default NotFoundPage;
